/**
 * Filtre « Partage » des listes Article / Tiers (migration 0132).
 * Sélection = liste d'ids de départements, PARTAGE_TOUS = « Partagés avec tous ».
 */

/** Valeur réservée : « Partagés avec tous les départements » (aucune restriction). */
export const PARTAGE_TOUS = 0;

/** Convertit la sélection en params de query pour l'API (partage_tous / partage_departements). */
export const partageToParams = (value?: number[] | null): Record<string, string> => {
  const ids = (value ?? []).filter((id) => id !== PARTAGE_TOUS);
  return {
    ...((value ?? []).includes(PARTAGE_TOUS) && { partage_tous: '1' }),
    ...(ids.length > 0 && { partage_departements: ids.join(',') }),
  };
};
